import { getChannelsApi } from './ChannelsServiceWrapper';
import { rewindDatatransform } from '../../utils/transformResponse/jawwyResponse';
// import { container } from '@intigral/domain/lib/DataDomain';
// import { DI } from '@intigral/constant/config/DIContainer';
// import { IPopcornService } from '@intigral/domain/lib/application/services/PopcornService';

export const getRewindChannelDataAPi = (rewindData) => {
    return new Promise((resolve, reject) => {
        if (rewindData && rewindData.data.entries) {
            const getChannels = getChannelsApi();
            getChannels.then((channels) => {
                resolve(rewindDatatransform(rewindData?.data, channels));
            });
        } else {
            reject(rewindData);
        }
    });

    // const popcornService = container.resolve<IPopcornService>(DI.SERVICES.IPopcornService);
    // return new Promise((resolve, reject) => {
    //     popcornService.getRewind(searchParams)
    //         .then((response) => {
    //             if (response && response.data.entries) {
    //                 const getChannels = getChannelsApi();
    //                 getChannels.then((channels) => {
    //                     resolve(rewindDatatransform(rewindData?.data, channels));
    //                 });
    //             } else {
    //                 reject(response);
    //             }
    //         })
    //         .catch((err) => reject(err));
    // });
};
